const {
    MOBILE_DEVICE,
    TABLET_DEVICE,
    IOS_OS_NAME,
    DEVICE_TO_PLATFORM_MAP
} = require('./constants');

/**
 * Checks if a given device type is a mobile device or not.
 * @param {String} deviceType The parsed ua parser device type.
 * @return {Boolean}
 */
const isMobile = (deviceType) => deviceType === MOBILE_DEVICE;

/**
 * Checks if a given device type is a touch device or not.
 * @param {String} deviceType The parsed ua parser device type.
 * @return {Boolean}
 */
const isTouch = (deviceType) => [MOBILE_DEVICE, TABLET_DEVICE].includes(deviceType);

/**
 * Returns the proper platform of a given device type.
 * @param {String} deviceType - The parsed device type.
 * @return {String}
 */
const getPlatform = (deviceType = '') => DEVICE_TO_PLATFORM_MAP[deviceType.toUpperCase()]
    || DEVICE_TO_PLATFORM_MAP.DESKTOP;

/**
 * Checks if a given os name is considered as IOS.
 * @param {String} osName - the parsed os name.
 * @return {Boolean}
 */
const isIos = (osName) => osName === IOS_OS_NAME;

module.exports = {
    isMobile,
    isTouch,
    isIos,
    getPlatform
};
